import { format } from "path";

export function CaseStudies() {
   
    if ($('body').find('.case-studies.section').length >= 1) {
        $(window).on("load", function () {
            WindowEvent();
        });

        $(window).on("resize", function () {
            WindowEvent();
        });
    };

    function WindowEvent() {
        var imageSets = $(".image-sets");

        var screenWidth = $(window).width();
        var isMobile = ($(imageSets).data('ismobile') == "True") && (screenWidth < 767);

        BannerImage(imageSets, isMobile, 'banner-image');
        CaseImage(imageSets, isMobile, 'case1-image');
        CaseVideoImage(imageSets, isMobile, 'case1-video-image');

        CaseImageWithBgImage(imageSets, isMobile, 'case2-image');
        CaseVideoImageWithImg(imageSets, isMobile, 'case2-video-image');

        ProcessBannerImage(imageSets, isMobile, 'process-banner-image');

        CaseImage(imageSets, isMobile, 'case3-image')
        CaseVideoImageWithImgAndBg(imageSets, isMobile, 'case3-video-image');

        RelatedCases(isMobile);

        $('.file-format').each(function () {
            var fileFormat: string = $(this).find('.format-id').text().split('.').pop();
			if (fileFormat.match('^jpg') || fileFormat.match('^jpeg') || fileFormat.match('^png') || fileFormat.match('^gif')) {
                $(this).addClass('image-format');
            } else {
                $(this).addClass('video-format');
            }
        });
    }

    function RelatedCases(isMobile: boolean) {
        $('.related-case').each(function() {
            if (isMobile) {
                var mobileUrl = $(this).data('mobileimageurl');
                if (mobileUrl == '') {
                    mobileUrl = $(this).data('imageurl');
                }
                $(this).attr('style', "background-image: url('" + mobileUrl + "')");
            } else {
                $(this).attr('style', "background-image: url('" + $(this).data('imageurl') + "')");

            }
        });
    }

    interface DataSet {
        element: any,
        url: string
    }

    function FindElementAndUrl(imageSets: any, target: string, isMobile: boolean): DataSet {
		var element = $('.case-studies.section .' + target);
		var windowWith = '?width='+ $(window).width();
		var url = $(imageSets).find('.' + target).data('url');
        var mobileUrl = $(imageSets).find('.mobile-' + target).data('url');

        return {
            element: element,
            url: (isMobile && (mobileUrl != '')) ? mobileUrl : url
        };
    }

    function BannerImage(imageSets: any, isMobile: boolean, target: string) {
        var data = FindElementAndUrl(imageSets, target, isMobile);
        var bgUrl = 'background-image:url(' + data.url + ')';
        var existingStyle = $(data.element).attr('style');

        if (existingStyle == '') {
            data.element.attr('style', bgUrl);
            return;
        }

        var splitStyle = existingStyle.split(';');
        var newStyle = splitStyle[0] + '; ' + bgUrl;

        data.element.attr('style', newStyle);
    }

    function CaseImage(imageSets: any, isMobile: boolean, target: string) {
        var hasCaseImage = $('.case-studies.section').find('.' + target).length >= 1;
        if (hasCaseImage) {
            var data = FindElementAndUrl(imageSets, target, isMobile);

            var format = $(data.element).find('.format-id');
            var img = $(data.element).find('.case-image img');
            var videoSrc = $(data.element).find('.case-video video source');

            var imageUrl = data.url;

            format[0].innerText = imageUrl;
            img.attr('src', imageUrl);
            videoSrc.attr('src', imageUrl);
        }
    }

    function CaseVideoImage(imageSets: any, isMobile: boolean, target: string) {

        var hasVideoImage = $('.case-studies.section').find('.' + target).length >= 1;
        if (hasVideoImage) {
            var data = FindElementAndUrl(imageSets, target, isMobile);

            var aRef = $(data.element).find('.case-image a')[0];
            var imageUrl = data.url;

			var style = "display: block; height: 100%; width: 100%; margin: 0 auto; cursor: pointer; background-image: url('/media/1963/homepage-play_fa.svg'), url('" + imageUrl + "'); background-position: center, center; background-repeat: no-repeat; background-size: 90px, cover;";
            $(aRef).attr('style', style);
        }
    }

    function CaseVideoImageWithImg(imageSets: any, isMobile: boolean, target: string) {
        var hasVideoImage = $('.case-studies.section').find('.' + target).length >= 1;
        if (hasVideoImage) {
            var data = FindElementAndUrl(imageSets, target, isMobile);

            var container = $(data.element).find('.video-container')[0];
            var img = $(container).find('a img')[0];

            $(container).attr('style', 'background-image: url(' + data.url + ');background-repeat: no-repeat;background-size: cover; background-position: center;');
            $(img).attr('src', data.url);
        }
    }

    function CaseVideoImageWithImgAndBg(imageSets: any, isMobile: boolean, target: string) {
        var hasVideoImage = $('.case-studies.section').find('.' + target).length >= 1;
        if (hasVideoImage) {
            var data = FindElementAndUrl(imageSets, target, isMobile);

            var container = $(data.element).find('.main-case-video a')[0];
            var img = $(container).find('img')[0];

			$(container).attr('style', "display: block;height: 100%;width: 100%;margin: 0 auto;cursor: pointer; background-image: url('/media/1963/homepage-play_fa.svg'), url('" + data.url + "');background-position: center,center;background-repeat: no-repeat;background-size: 90px, cover;");
            $(img).attr('src', data.url);
        }
    }

    function CaseImageWithBgImage(imageSets: any, isMobile: boolean, target: string) {
        var hasCaseImage = $('.case-studies.section').find('.' + target).length >= 1;
        if (hasCaseImage) {
            var data = FindElementAndUrl(imageSets, target, isMobile);

            var format = $(data.element).find('.format-id');
            var img = $(data.element).find('.case-image img');
            var videoSrc = $(data.element).find('.case-video video source');

            var imageUrl = data.url;

            $(data.element).attr('style', 'background: url(' + imageUrl + ') no-repeat 50% 0; background-size: cover;');
            format[0].innerText = imageUrl;
            img.attr('src', imageUrl);
            videoSrc.attr('src', imageUrl);
        }
    }

    function ProcessBannerImage(imageSets: any, isMobile: boolean, target: string) {
        var data = FindElementAndUrl(imageSets, target, isMobile);

        if (!isMobile) {
            $(data.element).attr('style', "background-image:url('" + data.url + "');");
        } else {
            var img = $(data.element).find('.case-image-banner img')[0];
            $(data.element).attr('style', '');
            $(img).attr('src', data.url);
        }
    }

}